import React from "react";
import "./Footer.css";
const Footer = () => {
  return (
    <div className="main-footer bg-dark mt-5">
      <div className="container mt-5">
        <div className="row mt-5">
          {/* GET IN TOUCH */}
          <div className="col-lg-3 col-sm-12">
            <h4>GET IN TOUCH</h4>
            <hr className="w-25 m-auto mb-2" />
            <h6 className="list-unstyled">
              <li>(+880)1832-725421</li>
              <li>info@tourandtravel.web.com</li>
              <li>Plot 31, Road 71, Dhanmondi</li>
              <li>Dhaka 1202, Bangladesh</li>
            </h6>
          </div>
          {/* OUR SERVICES */}
          <div className="col-lg-3 col-sm-12">
            <h4>OUR SERVICES</h4>
            <hr className="w-25 m-auto mb-2" />
            <h6 className="list-unstyled our-services">
              <li>Special Winter</li>
              <li>Couple Tour</li>
              <li>Family Tour</li>
              <li>Abroad Tour</li>
            </h6>
          </div>
          {/* QUICK LINKS */}
          <div className="col-lg-3 col-sm-12">
            <h4>QUICK LINKS</h4>
            <hr className="w-25 m-auto mb-2" />
            <h6 className="list-unstyled quick-links">
              <li>Blog</li>
              <li>Gallery</li>
              <li>Faq</li>
              <li>Offer's</li>
            </h6>
          </div>

          {/* SOCIAL LINK */}
          <div className="col-lg-3 col-sm-12">
            <h4>SOCIAL LINK</h4>
            <hr className="w-25 m-auto mb-2" />
            <div className="m-2">
              <i class="fab facebook fa-facebook-square p-2"></i>
              <i class="fab youtube fa-youtube p-2"></i>
              <i class="fab instagram fa-instagram p-2"></i>
              <i class="fab twitter fa-twitter p-2"></i>
              <i class="fab linkedin fa-linkedin-in p-2"></i>
            </div>
          </div>
        </div>
        <hr />
        <div className="row">
          <p className="col-sm">
            <span className="copy">&copy; </span>2021
            <span className="brand-name">
              Tour
              <span> &#38;</span> Travel
            </span>{" "}
            | All rights reserved | Terms Of Service | Privacy
          </p>
        </div>
      </div>
    </div>
  );
};

export default Footer;
